import client from '@/services/';

const state = () => ({
    all: [],
    one: {},
    fichier: [],

});

const getters = {
    all: state => state.all,
    one: state => state.one,
    fichier: state => state.fichier,

};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    },
    SET_FICHIER: (state, obj) => {
        state.fichier = obj;
    },
};

const actions = {
    async getAllP(cxt) {
        let data = await client.get('/formation');
        cxt.commit("SET_ALL", data);
        return data;
    },
    async getOne(cxt, code) {
        let data = await client.get('/formation/verification/' + code);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async create(cxt, payload) {
        let { data } = payload.id ? await client.put('/formation/' + payload.id, payload) : await client.post('/formation/add', payload);
        cxt.commit("SET_ONE", data);
        if (payload.id) {
            payload.id = null;
        }

        return data;
    },
    async del(cxt, id) {
        let { data } = await client.delete('/formation/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async uploadImage({ commit }, { payload }) {
        try {
            const data = await client.post('fichier/add/simple', payload, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            commit('SET_FICHIER', data);
            return data;

        } catch (error) {
            console.error('Erreur lors de l\'ajout du document :', error);
            throw error;
        }
    },
    async participer(cxt, payload) {
        let { data } = await client.post('/participants/add', payload);
        return data;
    },
    async getOneParticipant(cxt, id) {
        let data = await client.get('/participants/' + id);
        return data;
    },
    async getOneParticipant() {
        let data = await client.get('/participants/connected');
        return data;
    },
    async participantSignature(cxt, payload) {
        let { data } = await client.post('/participants/sign', payload);
        return data;
    },
    async participationIndividuel({ commit }, { formationCode, participantId }) {
        let { data } = await client.post(`/participants/signatures/${formationCode}/participant/${participantId}`);
        return data;
    },
    async participationGrouper({ commit }, formationCode) {
        let { data } = await client.get(`/participants/sent/attestation/${formationCode}`);
        return data;
    },
    async sendMailAgain({ commit }, code) {
        let { data } = await client.get(`/formation/resend/mail/${code}`);
        return data;
    },
    async sendFileFormation({ commit }, { formationCode, payload }) {
        let { data } = await client.post(`/participants/sent/support/${formationCode}`, payload);
        return data;
    },
    async getParticipantFormation(cxt, id) {
        let data = await client.get('/participants/formation/' + id);
        return data;
    },
    async rappelFormation({ commit }, formationCode) {
        let { data } = await client.get(`/participants/sent/rappel/${formationCode}`);
        return data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
